export default "/assets/images/app-screen2.117242a8b67893d8.jpg";